import { render, staticRenderFns } from "./processvvbbutton.vue?vue&type=template&id=5e878569&"
import script from "./processvvbbutton.vue?vue&type=script&lang=js&"
export * from "./processvvbbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports